import Endpoints from "@/config/ApiEndpoints.js";
import Axios from "axios";
import { required, email, minLength} from "vuelidate/lib/validators";
  export default {
    components: {
    },
    data() {
      return {
        ShowLoader: false,
        Saving: false,
        submitted: false,
        SearchKey: "",
        CompanyId:0,
        Modules:[],
        Permissions:['enable','add','edit','delete'],
        NewRole: {
          title: "",
          permissions: {},
        },
        selectAllRole:false
      };
    },
    validations: {
      NewRole: {
        title: { required },
      },
    },
    mounted() {
      document.title = pbx_SiteTitle + " - Role Add";
      this.CompanyId = JSON.parse(localStorage.getItem("Company")).id;
      this.GetModules();
    },
    methods: {
      GetModules() {
        var obj = { token: localStorage.getItem("token") };
        Axios.post(Endpoints.Modules.List, obj).then((Response) => {
          if (Response.data.success) {
            Axios.post(Endpoints.Roles.PermissionsList, obj).then((RoleResponse) => {
              if (RoleResponse.data.success) {
                var AccountRoesData = JSON.parse(RoleResponse.data.records);

                Response.data.records.forEach((element) => {
                  this.NewRole.permissions[element] = {};
                  this.Permissions.forEach((Permission) => {
                    this.NewRole.permissions[element][Permission] = false;
                  });
                    if (typeof AccountRoesData[element] != "undefined") {
                      this.NewRole.permissions[element] =
                      AccountRoesData[element];
                    }
                });
                setTimeout(() => {
                  this.Modules = Response.data.records;
                }, 400);
              }
            });
          }
        });
      },
      CreateRole() {
        this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        this.Saving = true;
        Axios.post(Endpoints.Roles.Create, {
          token: localStorage.getItem("token"),
          ...this.NewRole,
        }).then((Response) => {
          if (Response.data.success) {
            this.$swal.fire("New Role Added Successfully", "", "success").then(() => {
              this.Saving = false;
              this.$router.push("/account-roles/" );
            });
          } else {
            this.$swal.fire({
              title: "Oops!",
              text: Response.data.message,
              icon: "error",
              confirmButtonText: "Close",
            });
          }
        });
      },
      selectAllRoles(){
        if(this.selectAllRole == true){
          this.selectAllRole = false;
        }else{
          this.selectAllRole = true;
        }
        this.Modules.forEach((element) => {
          if (typeof this.NewRole.permissions[element] != "undefined") {
            Object.keys(this.NewRole.permissions[element]).forEach(
              (Permission) => {
                this.NewRole.permissions[element][Permission] =
                  this.selectAllRole;
              }
            );
          }
        });
      }      
    },
  };